import { render } from "./FormSearch2.vue?vue&type=template&id=01b16081"
import script from "./FormSearch2.vue?vue&type=script&lang=js"
export * from "./FormSearch2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__